<template>
	<b-container class="mt-4 h-95">
		<b-row class="h-100">
			<b-col class="d-flex flex-column">
				<b-row>
					<b-col class="h3">Quantitativo de Refeições</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form>
							<Fieldset
                ref="fieldset"
								legend="Filtros"
								:toggleable="true"
								class="px-3 pb-3"
							>
								<b-row>
									<b-col>
										<label for="data_inicial"
											>Data inicial</label
										>
										<b-form-datepicker
											id="data_inicial"
											v-model="data_inicial"
											:state="
												!$v.data_inicial.$error
													? null
													: false
											"
										></b-form-datepicker>
									</b-col>
									<b-col>
										<label for="data_final"
											>Data final</label
										>
										<b-form-datepicker
											id="data_final"
											v-model="data_final"
											:state="
												!$v.data_final.$error
													? null
													: false
											"
										></b-form-datepicker>
									</b-col>
								</b-row>
							</Fieldset>
							<b-row class="mt-2">
								<b-col>
									<b-button                    
										variant="success"
										@click="geraRelatorio"
										>Gerar relatório</b-button
									>
								</b-col>
							</b-row>
						</b-form>
					</b-col>
				</b-row>

				<b-overlay
					:show="loading"
					class="flex-grow-1 h-95 mr-0"
					:class="{ 'cursor-wait': loading }"
					style="resize: vertical; overflow: auto"
				>
					<b-row
						class="mt-2 flex-grow-1 h-100"
						v-show="isDisplayingReport"            
					>
						<b-col>
							<embed
								:src="src"
								width="100%"
								type="application/pdf"
								height="100%"
							/>
						</b-col>
					</b-row>
				</b-overlay>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import Fieldset from "primevue/fieldset";
import { required } from "vuelidate/lib/validators";

export default {
	data() {
		return {
			src: "",
			data_inicial: null,
			data_final: null,
			isDisplayingReport: false,
      loading: false
		};
	},
	components: {
		Fieldset,
	},
	methods: {
		geraRelatorio() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
        this.$refs.fieldset.toggle();
        this.isDisplayingReport = true;
        this.loading = true;
        this.$http({
					url: `/quantitativoderefeicoes?data_inicial=${this.data_inicial}&data_final=${this.data_final}`,
					responseType: "blob",
				}).then((response) => {
					var blob = new Blob([response.data], {
						type: "application/pdf",
					});
					var url = window.URL.createObjectURL(blob);
					this.src = url;
          this.loading = false;
          
				});				
			}
		},
	},
	validations: {
		data_inicial: {
			required,
		},
		data_final: {
			required,
		},
	},
};
</script>

<style strict>
.p-fieldset-legend {
	width: auto !important;
	font-size: 1rem !important;
}
.h-90 {
	height: 90%;
}
.h-95 {
	height: 95%;
}
.cursor-wait {
  cursor: wait;
}
</style>
